import React from 'react'
import { Helmet } from 'react-helmet';
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../store/recoil/tenant/atoms';

type PageTitlePropTypes = {
    showFirmInformation?: boolean,
    title: string
}

const PageTitle: React.FC<PageTitlePropTypes> = ({showFirmInformation, title}) => {
    const {firmInformations} = useRecoilValue(tenantState);
  return (
    <>
        <Helmet title={`e-Tahsilat -${showFirmInformation ? " " + firmInformations.firmName.toUpperCase(): " "} ${title}`}></Helmet>
    </>
  )
}

export default PageTitle;